import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaSearchPlus, FaExclamationCircle } from 'react-icons/fa';
import FloatingLabelInputAutoComplete from '../../ui/FloatingLabelInputAutoComplete';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import { getFileDetailsListByFilters, fetchSubClientData, fetchUploadedDataByFD,updatefiledetails,deletefiledetails, loadOptions } from '../../../services/client/customerApiService';
import { fetchServiceTypeData } from '../../../services/client/serviceTypeApiService';
import CustomRichTable from '../../common/CustomRichTable';
import { ProcessingOverlay } from '../../common/ProcessingOverlay';
import Swal from "sweetalert2";

const FileDetailsList = ({ handleTableRefresh}) => {
    const bgColorMapping = {
        Pending: "#FDE8E4",
        Completed: "#DAF4F0",
        Process: "#FEF4E4"
      };
      const textColorMapping = {
        Pending: "#F05648",
        Completed: "#0AB39C",
        Process: "#F78848"
      };
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [formValues, setFormValues] = useState({
        clientId: '',
        serviceTypeId: '',
        subClientId: '',
        checkinId: ''
    });
    const [subClients, setSubClients] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [customerFiles, setCustomerFiles] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null); // State for selected task
    const [component, setComponent] = useState(null);
    const navigate = useNavigate(); // Initialize useNavigate
    const [suggestions, setSuggestions] = useState([]);
    const [suggestionsLoading, setSuggestionsLoading] = useState(false);
    const inputClasses = (field) => (errors[field] ? 'border-red-500' : 'border-gray-300');
    const [isOpen, setIsOpen] = useState(false);
    const [templateContent, setTemplateContent] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const toggleDialog = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        const fetchServiceTypeByClient = async () => {
            try {
                const data = await fetchServiceTypeData(localStorage.getItem('clientID'));
                setServiceTypes(data.map(obj => ({ value: obj.serviceTypeId, label: obj.serviceType })));
            } catch (error) {
                console.error("Error fetching service types:", error);
            }
        };
        fetchServiceTypeByClient();
    }, []);

    useEffect(() => {
        const getSubClients = async () => {
            try {
                const subClientData = await fetchSubClientData(localStorage.getItem('clientID'));
                setSubClients(subClientData.map(subClient => ({
                    value: subClient.subClientId,
                    label: subClient.subClientName
                })));
            } catch (error) {
                console.error("Error fetching sub-clients:", error);
            }
        };
        getSubClients();
    }, []);

    const validate = () => {
        const newErrors = {};
        //if (!formValues.checkinId) newErrors.checkinId = 'Checkin ID Required!';
        return newErrors;
    };

    // Handle the change in the input field
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));

        // Trigger fetch if input length is at least 3 characters
        if (value.length >= 3) {
            fetchSuggestions(value);
        } else {
            setSuggestions([]); // Clear suggestions if input is less than 3 characters
        }
    };

    const handleSubmit = async (e) => {
        //e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                // Manually add the clientId here instead of relying on the setFormValues update
                const updatedFormValues = { ...formValues, clientId: localStorage.getItem('clientID') };

                //console.log(updatedFormValues); // You should see the clientId now included here
                const data = await getFileDetailsListByFilters(updatedFormValues);
                if (data.success && data.success.length > 0) {
                    const resultData = data.success;
                    const updatedData = resultData.map(item => {
                        let status = '';
                        switch(item.status) {
                          case 0:
                            status = 'Pending';
                            break;
                          case 1:
                           status = 'Process';
                            break;
                          case 2:
                            status = 'Completed';
                            break;
                            case 3:
                              status = 'Approved';
                              break;  
                          default:
                            status = '---';
                        }
                        return {
                          ...item,
                          status
                        };
                      });
                      setCustomerFiles(updatedData);
                    setApiResponse({ success: 'Files fetched successfully!' });
                } else {
                    setCustomerFiles([]);
                    setApiResponse({ error: 'No Data Found' });
                }
            } catch (error) {
                console.error("Submission failed:", error);
                setApiResponse({ error: 'Failed to submit form. Please try again.' });
                setCustomerFiles([]);
            } finally {
                setLoading(false);
                setErrors(validationErrors);
            }
        } else {
            setErrors(validationErrors);
        }
    };



    const resetFormValues = () => {
        setFormValues({
            serviceTypeId: '',
            subClientId: '',
            checkinId: ''
        });
        setErrors({});
    };

    const handleCancel = () => {
        resetFormValues();
        navigate('/televerificationlist');
    };
    const handleFormSubmit = (data) => {
        setSelectedTask(null);
        setCustomerFiles([]);
    };
    

    // Fetch suggestions from the server
    const fetchSuggestions = async (inputValue) => {
        setSuggestionsLoading(true); // Set loading to true
        try {
            const data = await loadOptions(inputValue);
            const suggestionsData = data.map((item) => ({ label: item, value: item }));
            setSuggestions(suggestionsData);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        } finally {
            setSuggestionsLoading(false); // Set loading to false after fetching
        }
    };

    // Handle when a user selects a suggestion
    const handleSelectSuggestion = (suggestion) => {
        setFormValues((prev) => ({ ...prev, checkinId: suggestion.label }));
        setSuggestions([]); // Clear suggestions after selection
    };
    const handleShowPopoUpSubmit = async (rowObject) => {
            setIsProcessing(true);
            try {
                const fetchUploadedData = await fetchUploadedDataByFD(rowObject.fileDetailsId);
                if (fetchUploadedData.statusCode === 1001) {
                    // Parse JSON string into an object
                    const parsedData = JSON.parse(fetchUploadedData.result);
    
                    // Add `fileDetailsId` only if it doesn't exist
                    if (!parsedData.hasOwnProperty('fileDetailsId')) {
                        parsedData.fileDetailsId = rowObject.fileDetailsId;
                    }
    
                    // Convert back to JSON string
                    const updatedResult = JSON.stringify(parsedData);
                    setTemplateContent(updatedResult);
    
    
                    toggleDialog(); // Open the dialog after fetching content
                }
            } catch (error) {
                console.error("Error fetching template:", error);
            } finally {
                setIsProcessing(false);
            }
        }
        const onSuccessUpdate = () => {
            //console.log(templateContent)
            setTemplateContent("");
            //setIsOpen(false);
            toggleDialog(); // Open the dialog after fetching content
            handleSubmit(); // Trigger re-fetching of files    
        }
    
const columns = [
        { Header: 'Client', accessor: 'subClientName' },
        { Header: 'Checkin ID', accessor: 'checkinId' },
        { Header: 'Applicant', accessor: 'customerName' },
        //{ Header: 'Address', accessor: 'address' },
        { Header: 'Component', accessor: 'componentName' },
        { Header: 'Executive', accessor: 'fieldOfficerName' },
        
        { Header: 'Date', accessor: 'createdDate' },
        {
          Header: 'Status',
          Cell: ({ row }) => (
            <p class={`px-2 py-1 w-fit rounded-md text-[9.75px] leading-[9.26px] font-semibold text-[#495057] 
                      text-[${textColorMapping[row.status]}] bg-[${bgColorMapping[row.status]}]`}>
              {row.status}
            </p>
          ),
        },
        {
            Header: 'Delete',
            Cell: ({ row }) => (
                <button className="mt-4 text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full" onClick={() => {
                    handleShowPopoUpSubmit(row);
                }
                }><FaSearchPlus /></button>
            ),
          },
        
      ];
    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form className="space-y-6 w-full">
                <h1>Assigned Components List</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        {loading ? (
                            <p>Loading Service Types...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Service Type"
                                id="serviceTypeId"
                                name="serviceTypeId"
                                value={serviceTypes.find(st => st.value === formValues.serviceTypeId) || null}
                                onChange={(option) => setFormValues({ ...formValues, serviceTypeId: option.value })}
                                className={inputClasses('serviceTypeId')}
                                options={serviceTypes}
                                isSearchable={true}
                            />
                        )}
                    </div>
                    <div>
                        <FloatingLabelSelect
                            label="Select Client"
                            id="subClientId"
                            name="subClientId"
                            value={subClients.find(subClient => subClient.value === formValues.subClientId) || null}
                            onChange={(option) => setFormValues({ ...formValues, subClientId: option.value })}
                            className={inputClasses('subClientId')}
                            options={subClients}
                            isSearchable={true}
                        />
                    </div>
                    <div>
                        <FloatingLabelInputAutoComplete
                            label="Checkin ID"
                            id="checkinId"
                            name="checkinId"
                            value={formValues.checkinId}
                            onChange={handleChange}
                            autocomplete="off" // Disable browser autocomplete
                            suggestions={suggestions}
                            onSelectSuggestion={handleSelectSuggestion}
                            loading={suggestionsLoading} // Pass loading state to the input
                            className="mb-4"
                        />
                        
                    </div>
                </div>

                <div className="flex gap-4">
                    <button
                        type="submit"
                        className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                        onClick={handleSubmit} disabled={loading}
                    >
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                    <button
                        id="filterButton"
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                </div>

                {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : ''
                            // (
                            //     <>
                            //         <FaCheckCircle className="mr-2" />
                            //         {apiResponse.success}
                            //     </>
                            // )
                        }
                    </motion.div>
                )}
            </form>
            <div>
                {customerFiles.length === 0 ? (
                    <p></p>
                ) : (
                    /*<div className="overflow-x-auto">
                        <table className="min-w-full table-auto">
                            <thead>
                                <tr className="bg-gradient-to-r from-indigo-600 to-indigo-500 text-white shadow-md">
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Client</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Checkin ID</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Applicant</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Address</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Assigned To</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Verification Type</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Status</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customerFiles.map((task, index) => (
                                    <tr key={task.taskId} className={`transition-all duration-300 ease-in-out 
                    ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} 
                    hover:bg-blue-50 hover:shadow-lg`}>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.subClientName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.checkinId}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.customerName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.address}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.fieldOfficerName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.componentName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.status}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">
                                            <button className="mt-4 text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full" onClick={() => {
                                                setSelectedTask(task)
                                                    ; setComponent(task.componentName);
                                            }
                                            }>Form</button>
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
*/
<CustomRichTable columns={columns} data={customerFiles}/>
                )}
            </div>
            <div>
{isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="relative bg-white w-11/12 max-w-4xl p-6 rounded shadow-lg overflow-auto max-h-screen">
                        {/* Close Button */}
                        <button
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                            onClick={toggleDialog}
                        >
                            ✖
                        </button>

                        {/* Render the template content as a JSON table */}
                        {templateContent && templateContent.length > 0 &&
                            <div>
                                <JsonTable data={templateContent} onSuccess={onSuccessUpdate} /></div>}
                    </div>
                </div>
            )}
            {/* Display the overlay when processing */}
            <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
                </div>
        </div>
    );
};




export default FileDetailsList;


const JsonTable = ({ data, onSuccess }) => {
    const [isEditable, setIsEditable] = useState(false);  // Track if the table is in editable state
    const [modifiedData, setModifiedData] = useState(data); // Store modified data
    const [isProcessing, setIsProcessing] = useState(false);

    // Check if data is a string and parse it if so
    let parsedData = modifiedData;
    if (typeof parsedData === 'string') {
        try {
            parsedData = JSON.parse(parsedData);
            setModifiedData(parsedData);
        } catch (e) {
            // If parsing fails, show an error message
            return <div className="text-red-500">Error: Invalid JSON string</div>;
        }
    }

    // Check if parsedData is an object
    if (!parsedData || typeof parsedData !== 'object') {
        return <div>No data available</div>;
    }

    // Get the keys of the object to display each key-value pair
    const keys = Object.keys(parsedData);

    const handleEditClick = () => {
        setIsEditable(!isEditable); // Toggle editable state
    };

    const handleInputChange = (e, key) => {
        setModifiedData({
            ...modifiedData,
            [key]: e.target.value,
        });
    };

    const handleSave = async () => {
            // Send modifiedData to API (for example)
            setIsProcessing(true);
            try {
                const data = await updatefiledetails(modifiedData);
                //console.log(data);
                if (!data.error) {
                    Swal.fire({
                        icon: "success",
                        title: "Success!",
                        text: data.success,
                        confirmButtonColor: "#4CAF50",
                        allowOutsideClick: false, // Prevent closing by clicking outside
                        allowEscapeKey: false,    // Prevent closing with the Escape key
                    }).then(() => {
                        setIsEditable(false);
                        if (onSuccess) onSuccess(); // Call the callback only if it exists
                    });
    
                } else {
                    Swal.fire("Error", 'Failed to submit form. Please try again.' + data.error, "error");
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setIsProcessing(false);
            }
        };

    const handleDeleteFileDetails = async (rowObject) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this component?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#4CAF50",
            confirmButtonText: "Yes, Delete it!",
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            setIsProcessing(true);
            try {
                const response = await deletefiledetails(modifiedData.fileDetailsId, localStorage.getItem('userID'));
                if (!response.error) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Your data has been Deleted successfully.",
                        confirmButtonColor: "#4CAF50",
                    }).then(() => {
                        setIsEditable(false);
                        if (onSuccess) onSuccess(); // Call the callback only if it exists
                    });
                } else {
                    Swal.fire("Error", "Failed to save data. " + response.error, "error");
                }
            } catch (error) {
                Swal.fire("Error", "An unexpected error occurred.", "error");
            } finally {
                setIsProcessing(false);
            }
        }

    }

    return (
        <div className="overflow-x-auto">
            <div className="flex justify-between items-center mb-4">
                <button
                    onClick={handleEditClick}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                >
                    {isEditable ? 'Cancel Edit' : 'Edit'}
                </button>
                {isEditable && (
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg"
                    >
                        Save Changes
                    </button>
                )}
            </div>
            <table className="min-w-full table-auto bg-white bg-opacity-30 shadow-lg rounded-lg border border-gray-200">
                <thead className="bg-blue-200 bg-opacity-80">
                    <tr>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Field</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Value</th>
                    </tr>
                </thead>
                <tbody>
                    {keys
                        .filter((key) => key !== "fileDetailsId")
                        .map((key, index) => (
                            <tr
                                key={key}
                                className={`${index % 2 === 0
                                    ? 'bg-blue-50 bg-opacity-70'
                                    : 'bg-green-50 bg-opacity-70'
                                    } hover:bg-blue-100 hover:bg-opacity-70 transition-colors duration-300`}
                            >
                                <td className="px-6 py-3 text-sm text-gray-800 font-medium">{key}</td>
                                <td className="px-6 py-3 text-sm text-gray-600">
                                    {isEditable ? (
                                        parsedData[key]?.length > 30 ? (
                                            <textarea
                                                value={parsedData[key]}
                                                onChange={(e) => handleInputChange(e, key)}
                                                className="px-4 py-2 border border-gray-300 bg-transparent rounded-md text-gray-800 focus:ring-2 focus:ring-blue-400 w-full h-24 resize-none"
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                value={parsedData[key]}
                                                onChange={(e) => handleInputChange(e, key)}
                                                className="px-4 py-2 border border-gray-300 bg-transparent rounded-md text-gray-800 focus:ring-2 focus:ring-blue-400"
                                            />
                                        )
                                    ) : (
                                        parsedData[key]
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
            <div className="text-right mt-4">
                <button
                    onClick={handleDeleteFileDetails}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg"
                    disabled={isProcessing}
                >
                    Delete
                </button>
            </div>

            {/* Display the overlay when processing */}
            <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
        </div>
    );
};



